import { Injectable } from "@angular/core";
import { UserAgentPublicApp } from "@maersk-global/iam-al";
import { environment } from "environments/environment";
import { IToken } from "app/_models/types";
import jwtDecode from "jwt-decode";
import * as dayjs from "dayjs";
import { ConfigService } from "./config.service";

interface TokenReturn {
  userEmail: string;
  token: string;
  accessToken: string;
  idToken: string;
}

Injectable({
  providedIn: "root",
});

export class LoginForgeRockService {
  private maxTokenRetrieveAttempts = 10
  constructor() {}

  _configService: ConfigService;

  SetConfig(conf: ConfigService) {
    this._configService = conf;
  }

  loginRedirect(redirectUri?: string) {
    try {
      const instance = new UserAgentPublicApp({
        authority: this._configService._config.forgeRockAuth.urlAuth,
        client_id: this._configService._config.forgeRockAuth.client_id,
        storage: {
          type: "localStorage",
        },
        redirect_uri: this._configService._config.forgeRockAuth.urlCallBack,
        post_logout_uri: this._configService._config.forgeRockAuth.urlCallBack,
      });

      if (!!redirectUri) {
        try {
          localStorage.setItem(`redirect_uri`, redirectUri);
        } catch (e) {}
      }

      instance.loginRedirect({
        scopes: ["openid", "profile", "email", "customer_code.any", "roles"],
        response_type: "code",
      });
    } catch (err) {}
  }

  private wait = (
    time: number
  ): Promise<void> =>
    new Promise((resolve) =>
      setTimeout(() => {
        resolve()
      }, time),
    )

  async getTokenRaw(): Promise<TokenReturn> {
    return new Promise(async (resolve, reject) => {
      try {
        let accessToken = '';
        let idToken = '';
        let attempts = 0;

        // Considerando o while para aguardar o retorno do forgerock. O retorno do forgerock não é awaitable.
        while (!accessToken && attempts < this.maxTokenRetrieveAttempts) {
          const instance = new UserAgentPublicApp({
            authority: this._configService._config.forgeRockAuth.urlAuth,
            client_id: this._configService._config.forgeRockAuth.client_id,
            storage: { type: "localStorage" },
            redirect_uri: this._configService._config.forgeRockAuth.urlCallBack,
            post_logout_uri: this._configService._config.forgeRockAuth.urlCallBack,
          });
          const storage = instance?.storage as any;
          accessToken = storage?.access_token || storage?.accessToken;
          idToken = storage?.id_token || storage?.idToken;
          attempts += 1
          await this.wait(1000)
        }

        if (attempts >= this.maxTokenRetrieveAttempts) {
          const error = new Error('MaxTokenAttemptsReached')
          reject(error)
        }

        const decodedIdentityToken: IToken = jwtDecode(idToken || accessToken);
        const decodedAccessToken: IToken = jwtDecode(accessToken);
        const userEmail = decodedIdentityToken.email || decodedAccessToken.email;
        const expiration = decodedAccessToken?.exp * 1000;
        const dueExpiration = dayjs(expiration).diff(dayjs(), "minute");

        localStorage.setItem("dataExpiracaoSessao", expiration.toString());

        const retorno = {
          userEmail,
          token: accessToken,
          accessToken,
          idToken,
        };

        if (dueExpiration > 5) resolve(retorno);
        else {
          this.limpaStorage();
          reject('token expirado')
        }
      } catch (err) {
        reject(err)
      }
    })
  }

  logout() {
    const instance = new UserAgentPublicApp({
      authority: this._configService._config.forgeRockAuth.urlAuth,
      client_id: this._configService._config.forgeRockAuth.client_id,
      storage: {
        type: "localStorage",
      },
      redirect_uri: this._configService._config.forgeRockAuth.urlCallBack,
      post_logout_uri: this._configService._config.forgeRockAuth.urlCallBack,
    });

    this.limpaStorage();
  }

  limpaStorage() {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/home";
  }
}
